import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const ProductTemperatureInternationalStepConfig: StepConfig = {
    type: FormType.PRODUCT_TEMPERATURE_INTERNATIONAL
};
